var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-tooltip',{attrs:{"data-testid":"ios14-disabled-hint-index-3vrgGA","disabled":_vm.disabled,"content":_vm.$t('module_ios14_optimize_goal_disable_hint'),"hide-delay":400,"placement":"top"}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }